// src/api/userDashboardApi.js

import axiosInstance from './axiosInstance';

export const fetchUserDashboard = async (userId) => {
  try {
    const response = await axiosInstance.get(`/dashboard/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user dashboard:', error);
    throw error;
  }
};
